import { authHeader } from '../../_helpers';
import axios from 'axios';

export const attritionPredictorSevice = {
    getAttrPreData,
}

axios.defaults.headers.common = authHeader();
let token = localStorage.getItem('access_token')


function getAttrPreData(data) {
    return axios.post(`/analytics/analytics_organisation/team/analyse/attrition_predictor/?access_token=${token}`,data)
        .then(response => {
            return response;
        });
}


// WEBPACK FOOTER //
// ./src/_services/Analyze/attritionPredictor.service.js